import React from "react";
import { Logo } from "@/components/Logo";

export const FinalClose = () => {
  return (
    <>
      <section
        data-testid="final-close-section"
        className="relative bg-stone-950 py-32 sm:py-48 lg:py-64 border-t border-stone-900 overflow-hidden"
      >
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(234,88,12,0.10),transparent_60%)]" />
        <div className="relative max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
          <p className="text-orange-500 font-sans-display text-xs uppercase tracking-[0.32em] mb-8">
            08 — Final
          </p>
          <h2
            className="font-serif-display text-stone-50 text-5xl sm:text-7xl lg:text-8xl leading-[0.92] tracking-tight"
            data-testid="final-close-headline"
          >
            Food That <em className="not-italic text-orange-500">Means</em>
            <br />
            Something.
          </h2>
          <p className="mt-10 font-serif-display italic text-stone-300 text-xl sm:text-2xl max-w-2xl mx-auto leading-relaxed">
            We&apos;re not just launching a food brand. We&apos;re creating a
            movement built on culture, flavour, and identity.
          </p>
          <p className="mt-6 font-proxima text-stone-500 text-xs uppercase tracking-[0.4em] font-semibold">
            Coming Soon. Be Ready.
          </p>
        </div>
      </section>

      <footer
        data-testid="site-footer"
        className="bg-stone-950 border-t border-stone-900 py-12"
      >
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 flex flex-col md:flex-row gap-6 items-start md:items-center justify-between">
          <Logo />
          <p className="font-sans-display text-stone-500 text-xs uppercase tracking-[0.24em] text-center">
            © {new Date().getFullYear()} Authentic Kitchen · GTA, Canada
          </p>
          <p
            data-testid="footer-firefly-credit"
            className="font-sans-display text-stone-500 text-xs uppercase tracking-[0.24em]"
          >
            Project by{" "}
            <span className="text-stone-300">Firefly Consulting Group</span>
          </p>
        </div>
      </footer>
    </>
  );
};

export default FinalClose;
